import { environment } from '@hakimo-ui/hakimo/environments';

export const SENTRY_DSN =
  'https://ae154f496153468cb6731cabe68b499c@o1288507.ingest.sentry.io/6557709';

export const INTERCOM_APP_ID = 'umr1vk9w';

export const isLocalOrAirgap =
  environment.name === 'LOCAL' || environment.name === 'AIRGAP';
